import { render } from "./codeGenerationDetails.vue?vue&type=template&id=dfcd12e2"
import script from "./codeGenerationDetails.vue?vue&type=script&lang=js"
export * from "./codeGenerationDetails.vue?vue&type=script&lang=js"

import exportComponent from "F:\\code\\ywym\\ydd-zht-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__